// extracted by css-extract-rspack-plugin
export default {"option":"FXZU2","selectItem":"eZRDp","actionIcon":"X09ZP","editable":"W7g2X"};